import mutations from './mutations';
import { DataService } from '@/config/dataService/dataService';
import { notification } from 'ant-design-vue';

const state = () => ({
    data: [],
    loading: false,
    error: null,
});

const actions = {
    async readFormByToken({ commit }, token) {
        commit('readFormByTokenBegin');
        await DataService.get(`/register/form/${token}`).then((response) => {
            commit('readFormByTokenSuccess', response.data.data);
        }).catch((err) => {
            commit('readFormByTokenErr', err);
        });
    },

    async registerContact({ commit }, payload) {
        commit('registerContactBegin');
        await DataService.post(`/register/contact`, payload).then((response) => {

            notification.success({
                message: response.data.message,
                placement: 'topRight',
            });
        }).catch((err) => {
            commit('registerContactErr', err);

            notification.error({
                message: err.message != undefined ? err.message : 'Error registering contact. Please contact support.',
                placement: 'topRight',
            });
        });
    },
};

export default {
    namespaced: false,
    state,
    actions,
    mutations,
};